import axios from "axios";
import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const RegistrarActividad = () => {
  const { id } = useParams(); // ID de la matrícula
  const navigate = useNavigate();

  const [nombreActividad, setNombreActividad] = useState("");
  const [descripcion, setDescripcion] = useState("");

  const [fecha] = useState(() => {
    const hoy = new Date();
    const year = hoy.getFullYear();
    const month = String(hoy.getMonth() + 1).padStart(2, "0");
    const day = String(hoy.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  });

  const [saving, setSaving] = useState(false);
  const disabledAll = useMemo(() => saving, [saving]);

  const cleanData = () => {
    setNombreActividad("");
    setDescripcion("");
  };

  const handleCancelar = () => {
    cleanData();
    navigate(-1);
  };

  const saveActividad = async () => {
  try {
    setSaving(true);

    const newActividad = {
      nombreActividad,
      fecha,
      descripcion,
    };

    const res = await axios.post(`/api/actividad/add/${id}`, newActividad);

    cleanData();

    await Swal.fire({
      icon: "success",
      title: "Actividad registrada",
      text: res.data?.mensaje || "Se registró correctamente.",
      timer: 1600,
      showConfirmButton: false,
    });

    // ✅ Volver a la vista anterior
    navigate(-1);

  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error al registrar",
      text: error.response?.data?.error || error.message,
    });
  } finally {
    setSaving(false);
  }
};


  const actions = async (e) => {
    e.preventDefault();
    await saveActividad();
  };

  return (
    <div className="bg-body-tertiary py-4">
      <div className="container-fluid px-2 px-md-4">
        <div className="bg-white border rounded-4 shadow-sm overflow-hidden">
          {/* Header */}
          <div className="px-3 px-md-4 py-3 border-bottom bg-white">
            <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
              <div>
                <h5 className="mt-2 mb-1 fw-semibold">Registrar actividad</h5>
                <small className="text-secondary">
                  Diligencia la información y guarda la actividad asociada a la matrícula.
                </small>
              </div>
            </div>
          </div>

          {/* Body */}
          <div className="p-3 p-md-4">
            {saving && (
              <div className="text-center text-secondary py-3">
                <div className="spinner-border" role="status" aria-hidden="true" />
                <div className="mt-2">Guardando actividad…</div>
              </div>
            )}

            <form onSubmit={actions}>
              <div className="row g-3">
                <div className="col-12 col-md-9">
                  <label className="form-label fw-semibold">Nombre de la Actividad</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej. Taller de diagnóstico"
                    required
                    value={nombreActividad}
                    onChange={(e) => setNombreActividad(e.target.value)}
                    disabled={disabledAll}
                  />
                </div>

                <div className="col-12 col-md-3">
                  <label className="form-label fw-semibold">Fecha</label>
                  <input type="date" className="form-control" value={fecha} readOnly />
                  <div className="form-text">Se toma la fecha de hoy automáticamente.</div>
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">Descripción de la Actividad</label>
                  <textarea
                    className="form-control"
                    rows={4}
                    placeholder="Describe brevemente el objetivo y desarrollo de la actividad..."
                    required
                    value={descripcion}
                    onChange={(e) => setDescripcion(e.target.value)}
                    disabled={disabledAll}
                  />
                </div>
              </div>

              {/* Footer botones */}
              <div className="d-flex justify-content-end gap-2 mt-4 flex-wrap">
    
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={cleanData}
                  disabled={disabledAll}>
                  <i className="fa-solid fa-eraser me-2"></i>
                  Limpiar
                </button>

                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={handleCancelar}
                  disabled={disabledAll}>
                  <i className="fa-solid fa-xmark me-2"></i>
                  Cancelar
                </button>

                 <button type="submit" className="btn btn-dark" disabled={disabledAll}>
                  <i className={`fa-solid ${saving ? "fa-spinner fa-spin" : "fa-floppy-disk"} me-2`}></i>
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrarActividad;
